/**加载**/
<template>
  <div class="uploadMod" v-if="state">
    <span class="uploadIcon">
      <div class="rect1 rect"></div>
      <div class="rect2 rect"></div>
      <div class="rect3 rect"></div>
      <div class="rect4 rect"></div>
      <div class="rect5 rect"></div>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'xk-uploadMod',
    computed: {},
    props: ['state'],
    data () {
      return {
      }
    },
    methods: {},
    watch: {},
    mounted: function () {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  @-webkit-keyframes stretchdelay {
    0%, 40%, 100% {
      -webkit-transform: scaleY(0.4)
    }
    20% {
      -webkit-transform: scaleY(1.0)
    }
  }

  @keyframes stretchdelay {
    0%, 40%, 100% {
      transform: scaleY(0.3);
      -webkit-transform: scaleY(0.3);
    }
    20% {
      transform: scaleY(1.0);
      -webkit-transform: scaleY(1.0);
    }
  }

  .uploadMod {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-color: rgba(255, 255, 255, .8);
    left: 0;
    top: 0;
    .uploadIcon {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      .rect {
        width: 6px;
        transform-origin: 50% 50%;
        height: 30px;
        background-color: #ff6000;
        display: inline-block;
        animation: stretchdelay 1.3s infinite ease-in-out;
      }
      .rect2 {
        animation-delay: -1.1s
      }
      .rect3 {
        animation-delay: -1s;
      }
      .rect4 {
        animation-delay: -0.9s
      }
      .rect5 {
        animation-delay: -0.8s
      }
    }
  }
</style>



// WEBPACK FOOTER //
// uploadMod.vue?267763d9